<template>
  <div id="app">
    <Header></Header>
    <router-view/>
  </div>
</template>

<script>
import store from '@/store';
import * as api from '@/api/index';
import Header from '@/views/header';

export default {
  name: 'App',
  components: {
    Header
  },
  beforeMount() {
      this.getGameList()
  },
  methods: {
    async getGameList() {
        let result = await api.reqGameList()
        if(result.status == 200) {
          store.setGameListAction(result.data.game_list)
        }else {
          alert(result.data)
        }
    }
  }
}
</script>

<style>
@import "~@/assets/common/base.scss";
@import "~@/assets/common/font.scss";
</style>
